export function appendPromotionalAdvertisements(
  formData,
  list = [],
  deleteList = []
) {
  list.forEach((val, index) => {
    formData.append(
      `promotionalAdvertisementList[${index}].default`,
      val.default || false
    );
    formData.append(
      `promotionalAdvertisementList[${index}].advertisementImageLink`,
      val.advertisementImageLink || ""
    );
    formData.append(
      `promotionalAdvertisementList[${index}].promotionalProductName`,
      val.promotionalProductName || ""
    );

    if (!val.advertisementId) {
      if (val.advertisementImages) {
        formData.append(
          `promotionalAdvertisementList[${index}].advertisementImage`,
          val.advertisementImages
        );
      }
    } else if (val.advertisementImages) {
      formData.append(
        `promotionalAdvertisementList[${index}].advertisementId`,
        val.advertisementId
      );
      formData.append(
        `promotionalAdvertisementList[${index}].advertisementImage`,
        val.advertisementImages
      );
    } else {
      formData.append(
        `promotionalAdvertisementList[${index}].advertisementId`,
        val.advertisementId
      );
      formData.append(
        `promotionalAdvertisementList[${index}].existingAdvertisementImage`,
        val.advertisementImage || ""
      );
    }
  });

  deleteList.forEach((id, index) => {
    formData.append(
      `deletePromotionalAdvertisementList[${index}].advertisementId`,
      id
    );
  });
}

export function normalizePromotionalAdvertisements(list) {
  const safeList = list || [];
  return safeList.map(ad => ({
    advertisementId: ad.advertisementId || null,
    promotionalProductName: ad.promotionalProductName || "",
    advertisementImageLink: ad.advertisementImageLink || "",
    advertisementImage: ad.advertisementImage || "",
    advertisementImages: null,
    previewUrl: null,
    default: !!(ad.default ?? ad.isDefault)
  }));
}

export function mapAdsForPreview(list) {
  const safeList = list || [];
  return safeList
    .filter(
      ad =>
        ad.previewUrl ||
        ad.advertisementImage ||
        ad.promotionalProductName ||
        ad.advertisementImageLink
    )
    .map(ad => ({
      ...ad,
      advertisementImage: ad.previewUrl || ad.advertisementImage || null
    }));
}
